import React from 'react';

export default [
	{
		name: 'DIVIGEO',
		id: 'divigeo',
		content: (
			<>
				<p>
					O DiviGeo é composto por um software voltado à Gestão
					Territorial e um GeoPortal, que apresentam customizações
					necessárias para atender às necessidades de manutenção e
					visualização integrada das bases de dados Geoespaciais do
					Cadastro Territorial do município de Divinópolis.
				</p>

				<p>
					O projeto teve como objetivo a atualização e modernização da
					base de dados cadastral e territorial. Foram contempladas as
					seguintes etapas: Planejamento do projeto; Levantamento
					Aerofotogramétrico e Perfilamento a Laser; Geração de
					Ortofotos e Modelos Topográficos; Digitalização e
					Georreferenciamento de plantas do acervo da Prefeitura; Base
					Cartográfica, através da geocodificação de logradouros,
					quadras e lotes; Levantamento fotográfico multidirecional;
					Cálculo de Área das edificações; Levantamento em Campo;
					Implantação do Sistema de Gestão Territorial; Customização;
					Criação de banco de dados e migração; Treinamento; Manuais
					do sistema e Suporte técnico. É importante ressaltar que o
					projeto foi realizado na área urbana do município.
				</p>

				<p>
					O DiviGeo é composto por diversos módulos e camadas. O
					sistema é utilizado e gerido por grande parte das
					secretarias e órgãos municipais. As informações são
					atualizadas pelo setor da administração municipal
					responsável, conforme demanda das demais Secretarias.
				</p>

				<p>
					Dentre várias funcionalidades para uso interno da
					prefeitura, o sistema também fornece serviços ao cidadão,
					através do GeoPortal, objetivando a desburocratização na
					gestão pública: como geração de informação básica de um lote
					e outros documentos; localização de serviços de saúde,
					educação, assistência social, patrimônio histórico e
					cultural entre outros; espacialização da legislação
					urbanística e ambiental municipal; consulta a dados
					espaciais públicos; e sistematização de dados
					georreferenciados provenientes de órgãos oficiais. Além
					dessas, são disponibilizadas também outras funcionalidades
					com o intuito de contribuir para a transparência da gestão
					pública.
				</p>

				<p>
					A Infraestrutura é baseada em tecnologias livres, contém
					mapas temáticos, ortofotos e ortomosaicos integrados com
					dados vetoriais e alfanuméricos. Permite a manutenção da
					base cartográfica oficial do município, sincronizada com
					base de dados alfanumérica, mantendo a integridade e
					qualidade dos dados disponíveis. Além disso, o sistema
					permite realizar o cadastro de objetos territoriais,
					feições, análises espaciais e geração de mapas para
					impressão.
				</p>
				<br />
				<h3>Sobre o Sistema </h3>
				<p>
					O projeto utiliza as linguagens de back-end denominada Ruby,
					associada ao framework Ruby on Rails, e recursos de
					programação front-end HTML5, CSS, Java Script, ExtJS e Open
					Layers e como ambiente de desenvolvimento foi utilizado o
					Microsoft Visual Studio Code, para a ferramenta de cadastro.
				</p>
				<br />
				<p>
					<strong>Características técnicas da plataforma Web</strong>
				</p>
				<p>Sistema Operacional (SO): Linux Ubuntu Server 20.04 LTS.</p>
				<p>Software de Geoprocessamento Web: Geoserver</p>
				<p>Software de Geoprocessamento Desktop: QGIS</p>
				<p>
					Gerenciador de Banco de Dados: software PostgreSQL® com o
					PostGIS®
				</p>
				<p>Software de Banco de Dados: PG Admin IV e DBeaver</p>
				<p>Banco de Dados: PostgreSQL</p>
				<p>Extensão Espacial: PostGIS</p>
				<p>
					Browser Suportados: Microsoft Edge 15, Google Chrome build
					60.0.3112.112, Mozilla Firefox 54, Safari 11.0.3 ou
					superiores.
				</p>
			</>
		),
	},
];
